import { useQuery } from "@tanstack/react-query";
import { vocabService } from "../services/vocabService";

export const useVocabData = (pageIndex) => {
  return useQuery({
    queryKey: ["vocabData", pageIndex],
    queryFn: () => vocabService.getWordList(pageIndex),
    staleTime: Infinity,
    cacheTime: Infinity,
    select: (data) => ({
      words: data[0],
      wordsNative: data[1],
      sentences: data[2],
      sentencesNative: data[3],
    }),
  });
}
